export function scrollLink(wrapper = "scroll-link") {
    let smoothScrollLinks = document.querySelectorAll("." + wrapper);

    smoothScrollLinks.forEach(link => {
        let targetId = link.getAttribute('href').substring(1);
        let targetSection = document.getElementById(targetId);
        let headerOffset = parseInt(link.getAttribute('data-header-offset')) || 120;
        let linkColor = link.getAttribute('data-color') || 'primary';
        let changeColor = link.getAttribute('data-changecolor') || true;
        changeColor = changeColor == 'false' ? false : true;

        let navLink = link.classList.contains("nav-link");
        window.addEventListener('scroll', function () {
            let setLinkColor = linkColor == 'white' ? '!text-primary-300' : '!text-primary-500';
            let scrollPosition = window.scrollY || window.pageYOffset;
            if (navLink) {
                let sections = document.querySelectorAll('.scrollSection');

                let activeSectionIndex = -1;
                for (let i = 0; i < sections.length; i++) {
                    let sectionTop = sections[i].offsetTop - headerOffset;
                    let sectionHeight = sections[i].offsetHeight + headerOffset;
                    let sectionBottom = sectionTop + sectionHeight - headerOffset;

                    if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                        activeSectionIndex = i;
                        break;
                    }
                }

                if(changeColor) {
                    // Clear all active links
                    link.classList.remove(setLinkColor);

                    if (activeSectionIndex !== -1 && smoothScrollLinks) {
                        if (smoothScrollLinks[activeSectionIndex]) {
                            if (smoothScrollLinks[activeSectionIndex].classList.contains("nav-link")) {
                                smoothScrollLinks[activeSectionIndex].classList.add(setLinkColor);
                            } else {
                                smoothScrollLinks[activeSectionIndex].classList.add(setLinkColor);
                            }
                        }
                    }
                }
            }
            else {
                if (targetSection && changeColor) {
                    if (
                        scrollPosition >= targetSection.offsetTop - headerOffset &&
                        scrollPosition < targetSection.offsetTop + targetSection.offsetHeight - headerOffset
                    ) {
                        link.classList.add(setLinkColor);
                    } else {
                        link.classList.remove(setLinkColor);
                    }
                }
            }
        });

        link.addEventListener('click', function(e) {
            e.preventDefault();

            if (targetSection) {
                window.scroll({
                    behavior: 'smooth',
                    top: targetSection.offsetTop - headerOffset,
                });
            }
        });
    });

    window.addEventListener('load', () => {
        if (window.location.hash) {
            var targetElement = document.querySelector(window.location.hash);

            if (targetElement) {
                window.scroll({
                    behavior: 'smooth',
                    top: targetElement.offsetTop - 155
                });
            }
        }
    });
}
